import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react/index.js'
import {useSuiContext} from '@s-ui/react-context'
import PrimitiveTypography, {primitiveTypographyDesign} from '@s-ui/react-primitive-typography'
import NetInput from '@adv-mt/mt-net-input'

const BASE_CLASS = 'mt-NetDrawer-footer'
const TERMS_CLASS = `${BASE_CLASS}-terms`

const NetChatFooter = ({onSubmit, disabled}) => {
  const {i18n, domain} = useSuiContext()

  const config = domain.get('config')
  const isMobile = config.get('isMobile')

  return (
    <div className={BASE_CLASS}>
      <NetInput onSubmit={onSubmit} disabled={disabled} autoFocus={!isMobile} />
      <PrimitiveTypography design={primitiveTypographyDesign.CAPTION} className={TERMS_CLASS}>
        {htmlStringToReactElement(
          i18n.t('NET.TERMS', {
            linkStartTerms: `<a className="${TERMS_CLASS}-link" href="/condiciones-de-uso/#18-contenido-generado-con-ia" target='_blank' rel="noopener">`,
            linkEndTerms: '</a>',
            linkStartPrivacy: `<a className="${TERMS_CLASS}-link" href="/condiciones-de-uso/#privacidad" target='_blank' rel="noopener">`,
            linkEndPrivacy: '</a>'
          })
        )}
      </PrimitiveTypography>
    </div>
  )
}

NetChatFooter.displayName = 'NetChatFooter'

NetChatFooter.propTypes = {
  onSubmit: PropTypes.func,
  disabled: PropTypes.bool
}

export default NetChatFooter
